import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ErrorState, PageLoading } from '../components/ui/States'
import { useAuth } from './providers/auth-context'
import { isSuperadmin } from '../features/auth/permissions'

export function ProtectedRoute() {
  const { session, loading, error, mfaRequired } = useAuth()
  const location = useLocation()
  if (loading) return <PageLoading label="Menyemak sesi" />
  if (error && session) return <ErrorState error={error} />
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (mfaRequired && location.pathname !== '/auth/mfa') {
    return <Navigate to="/auth/mfa" replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}

export function AlumniRoute() {
  const { access, loading } = useAuth()
  if (loading) return <PageLoading label="Menyemak akses" />
  if (!access) return <Navigate to="/login" replace />
  if (!access.profileId || access.accountStatus !== 'active' || !access.roles.includes('alumni'))
    return <Navigate to="/app/status" replace />
  return <Outlet />
}

export function StatusRoute() {
  const { access, loading } = useAuth()
  if (loading) return <PageLoading />
  if (!access) return <Navigate to="/login" replace />
  if (access.accountStatus === 'active') {
    return <Navigate to={isSuperadmin(access.roles) ? '/admin' : '/app'} replace />
  }
  return <Outlet />
}

export function ProfileSettingsRoute() {
  const { access, loading } = useAuth()
  if (loading) return <PageLoading label="Menyemak akses profil" />
  if (!access) return <Navigate to="/login" replace />
  if (
    !access.profileId ||
    !['active', 'pending_verification', 'rejected'].includes(access.accountStatus)
  ) {
    return <Navigate to="/app/status" replace />
  }
  return <Outlet />
}

export function AdminRoute() {
  const { access, loading } = useAuth()
  if (loading) return <PageLoading label="Menyemak peranan pentadbir" />
  if (!access || access.accountStatus !== 'active' || !access.canAccessAdmin) {
    return <Navigate to="/app/status" replace />
  }
  return <Outlet />
}

export function GlobalOperationsRoute() {
  const { access, loading } = useAuth()
  if (loading) return <PageLoading label="Menyemak akses operasi global" />
  if (!access || !access.canManageGlobalOperations || access.accountStatus !== 'active') {
    return <Navigate to="/admin/applications" replace />
  }
  return <Outlet />
}

export function SuperadminRoute() {
  const { access, loading } = useAuth()
  if (loading) return <PageLoading label="Menyemak akses superadmin" />
  if (!access || !isSuperadmin(access.roles) || access.accountStatus !== 'active') {
    return <Navigate to="/admin/applications" replace />
  }
  return <Outlet />
}
